"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectedIcon = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('span')(({
  ownerState: {
    isSelected
  },
  theme
}) => ({
  boxSizing: 'content-box',
  color: isSelected ? theme.palette.success.main : theme.palette.grey[200],
  fontSize: '3.6rem',
  height: 36,
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  width: 36,
  zIndex: 1,
  [`& .${_mui.svgIconClasses.root}`]: {
    display: 'block'
  }
}));
const SelectedIcon = ({
  isSelected
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(Root, {
  ownerState: {
    isSelected
  },
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckCircleFilled, {
    fontSize: "inherit"
  })
});
exports.SelectedIcon = SelectedIcon;